import { LinearProgress } from "@mui/material";
import type { FC, ReactNode } from "react";
import { useSupabaseLoader } from "../../server/supabase/hooks";
import { AppError } from "../generic/components/errors/app-error";
import { getAllAccountLimits } from "../generic/hooks/use-account-limit";
import { AccountLimitProvider } from "./account-limit-context";

export const AccountLimits: FC<{ children: ReactNode }> = ({ children }) => {
  const {
    loading,
    error,
    data: limits,
  } = useSupabaseLoader(async ({ supabase, account_id }) => {
    return await getAllAccountLimits(supabase, account_id);
  }, []);

  if (loading) return <LinearProgress />;
  if (error) {
    console.error("Failed to load account limits:", error);
    return <AppError onRetry={() => {}} />;
  }

  return <AccountLimitProvider limits={limits}>{children}</AccountLimitProvider>;
};
